"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ServerStyleSheets.default;
  }
});

var _ServerStyleSheets = _interopRequireDefault(require("./ServerStyleSheets"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/styles/ServerStyleSheets/index.js
// module id = 173
// module chunks = 0